import { UserDto } from '@act/shared/data-transfer-objects';

export const displayName = (
  member: UserDto,
  options?: {
    hideLastName?: boolean;
    onlyFirstInitial?: boolean;
    onlyLastInitial?: boolean;
  }
) => {
  if (!member) return 'Unknown';

  const firstName = capitalizeFirstLetter(
    member?.firstName,
    options?.onlyFirstInitial
  );
  const lastName = capitalizeFirstLetter(
    member?.lastName,
    options?.onlyLastInitial
  );
  const space = firstName && lastName ? ' ' : '';

  const name =
    !options?.hideLastName && member.lastName
      ? `${firstName || ''}${space}${lastName || ''}`
      : firstName;

  return name;
};

export const capitalizeFirstLetter = (name: string, onlyInitial?: boolean) => {
  if (!name) return '';

  const initial = name?.slice(0, 1)?.toLocaleUpperCase();
  return onlyInitial ? `${initial}.` : initial + name?.slice(1);
};

export const pronounsFormatter = (pronouns: string) => {
  if (!pronouns) return '';
  // Trim pronoun formatting from they/them/theirs -> they/them
  return pronouns
    .split('/')
    .map(p => p.trim())
    .slice(0, 2)
    .join('/');
};
